import clsx from 'clsx'

import styles from './CustomIcon.module.scss'

interface CustomIconProps {
  name: string
  size?: number
  className?: string
}

export const CustomIcon = ({ name, size = 20, className, ...rest }: CustomIconProps) => (
  <div>
    <img
      className={clsx(styles.icon, className)}
      src={`/assets/svg/coffee-match/${name}.svg`}
      alt={name}
      width={size}
      height={size}
      aria-hidden="true"
      {...rest}
    />
  </div>
)
